"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Occ_Paragraph = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Occ_Paragraph = (0, _styledComponents["default"])('p')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: ", ";\n    font-family: ", ";\n    margin: ", ";\n    line-height: 1.3;\n    font-size: ", ";\n    font-weight: ", ";\n    color: ", ";\n    text-transform: ", ";\n    text-align: ", ";\n    display: ", ";\n    flex-direction: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  if (props.service) {
    return 'var(--font-family-primary)';
  } else {
    return 'var(--font-family-secondary)';
  }
}, function (props) {
  return props.auto ? '0 auto' : 0;
}, function (props) {
  if (props.service) {
    return '12px';
  } else if (props.size === 'base') {
    return 'var(--font-size-base)';
  } else if (props.size === 'xxxs') {
    return 'var(--font-size-xxxs)';
  } else if (props.size === 'xxs') {
    return 'var(--font-size-xxs)';
  } else if (props.size === 'xs') {
    return 'var(--font-size-xs)';
  } else if (props.size === 'sm') {
    return 'var(--font-size-sm)';
  } else if (props.size === 'md') {
    return 'var(--font-size-md)';
  } else if (props.size === 'lg') {
    return 'var(--font-size-lg)';
  } else if (props.size === 'xl') {
    return 'var(--font-size-xl)';
  } else if (props.size === 'xxl') {
    return 'var(--font-size-xxl)';
  } else if (props.size === 'xxxl') {
    return 'var(--font-size-xxxl)';
  } else if (props.size === 'xxxxl') {
    return 'var(--font-size-xxxxl)';
  } else {
    return 'var(--font-size-xs)';
  }
}, function (props) {
  if (props.weight === 'normal') {
    return 'var(--font-weight-normal)';
  } else if (props.weight === 'hairline') {
    return 'var(--font-weight-hairline)';
  } else if (props.weight === 'thin') {
    return 'var(--font-weight-thin)';
  } else if (props.weight === 'light') {
    return 'var(--font-weight-light)';
  } else if (props.weight === 'middle') {
    return 'var(--font-weight-middle)';
  } else if (props.weight === 'semibold') {
    return 'var(--font-weight-semibold)';
  } else if (props.weight === 'bold') {
    return 'var(--font-weight-bold)';
  } else if (props.weight === 'extrabold') {
    return 'var(--font-weight-extrabold)';
  } else if (props.weight === 'black') {
    return 'var(--font-weight-black)';
  } else {
    return 'var(--font-weight-normal)';
  }
}, function (props) {
  if (props.color === 'white') {
    return 'var(--color-base-white)';
  } else if (props.color === 'primary') {
    return 'var(--color-primary)';
  } else if (props.color === 'secondary') {
    return 'var(--color-secondary)';
  } else if (props.color === 'error') {
    return 'var(--color-red-600)';
  } else if (props.color === 'muted') {
    return 'var(--color-font-muted)';
  } else {
    return 'var(--color-font-base)';
  }
}, function (props) {
  if (props.transform === 'capitalize') {
    return 'capitalize';
  } else if (props.transform === 'uppercase') {
    return 'uppercase';
  } else if (props.transform === 'lowercase') {
    return 'lowercase';
  }
}, function (props) {
  if (props.align === 'left') {
    return 'left';
  } else if (props.align === 'right') {
    return 'right';
  } else if (props.align === 'center') {
    return 'center';
  } else if (props.align === 'initial') {
    return 'initial';
  } else if (props.align === 'inherit') {
    return 'inherit';
  }
}, function (props) {
  return props.forceMultiline && 'flex';
}, function (props) {
  return props.forceMultiline && 'column';
});
exports.Occ_Paragraph = Occ_Paragraph;